/**
 * How to approach resource (CT-5714): the white card beside the Next Best
 * Action — how to reach the person, their role, what to send, how to name them —
 * each row pointing at the trait or insight it came from.
 *
 * Fed from Intelligence and not user-editable. No contract has been shared yet:
 * the path is ASSUMED, `TODO(CT-5714 / backend)`. Real signature, snake_case
 * body; only the transport is stubbed.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

export { __resetMockApproachForTests, __setMockApproachScenario } from './__mocks__/approach.mock.js';

const mapSource = (raw) => (raw?.kind && raw?.id ? { kind: raw.kind, id: raw.id } : null);

/**
 * Rows come from `fields` as the payload orders them — no per-key or per-type
 * code. A field the payload leaves out has no row; a row without a source is
 * plain text.
 */
export const mapApiHowToApproachToUi = (raw = {}) => ({
  updatedAt: raw.updated_at ?? raw.updatedAt ?? null,
  traitCount: raw.trait_count ?? raw.traitCount ?? 0,
  insightCount: raw.insight_count ?? raw.insightCount ?? 0,
  restricted: Boolean(raw.restricted ?? false),
  fields: (raw.fields ?? []).map((field) => ({
    key: field.key ?? '',
    label: field.label ?? '',
    value: field.value ?? '',
    source: mapSource(field.source),
  })),
});

/** TODO(CT-5714 / backend): `POST /v0/profile/approach/get` with `{ entity_type, entity_id }`. */
export const getHowToApproach = async ({ entityType, entityId } = {}) => {
  const response = await request('/v0/profile/approach/get', { entity_type: entityType, entity_id: entityId });
  return validateApiResponse(response, 'Failed to load How to approach');
};
